import i18n from 'vl-common/src/lib/i18n';
import React, { forwardRef } from 'react';
import { Input, InputProps, InputRef } from 'antd';
import { RegistrationFormItem, type RegistrationFormItemProps } from '../RegistrationFormItem';

const t = i18n.getFixedT(null, 'main');

export const EmailFormItem = forwardRef<
  InputRef,
  RegistrationFormItemProps & {
    inputProps?: InputProps;
  }
>(({ inputProps, ...props }, ref) => (
  <RegistrationFormItem
    label={t('Email Address')}
    name="email"
    required
    validateTrigger="onBlur"
    rules={[
      {
        type: 'email',
        message: 'Please input your e-mail address!'
      },
      { required: true, message: 'Please input your e-mail address!' }
    ]}
    {...props}
  >
    <Input type="email" autoComplete="off" data-testid="email" ref={ref} {...inputProps} />
  </RegistrationFormItem>
));
